module.exports = __webpack_public_path__ + "static/media/23_plantilla_combo_rectangular_marco_comida_62.6c9b1345.png";